module.exports = __webpack_public_path__ + "assets/normal/images/Empty_3.0c20dbd0.png";